import type { AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency';

export type AttributionPlatform = 'ios' | 'android';

export type AttributionPayload = {
  appsflyer_id: string;
  platform: AttributionPlatform;
  att_status: AppTrackingStatus | null;
  os_version: string | null;
};

const isNativePlatform = (platform: string): platform is AttributionPlatform =>
  platform === 'ios' || platform === 'android';

export const collectAttributionPayload = ({
  uid,
  platform,
  attStatus,
  osVersion,
}: {
  uid: string;
  platform: string;
  attStatus: AppTrackingStatus | null;
  osVersion: string | null;
}): AttributionPayload | null => {
  if (!uid || !isNativePlatform(platform)) return null;
  return {
    appsflyer_id: uid,
    platform,
    att_status: platform === 'ios' ? attStatus : null,
    os_version: osVersion || null,
  };
};

export const isSameAttribution = (
  previous: AttributionPayload | null,
  next: AttributionPayload,
): boolean =>
  previous !== null &&
  previous.appsflyer_id === next.appsflyer_id &&
  previous.platform === next.platform &&
  previous.att_status === next.att_status &&
  previous.os_version === next.os_version;
